// VPDZasedaniyaPravleniyaFederatsiiTekst
import React, { } from 'react';
import { useSelector } from 'react-redux';
import { InputNumber, Form, Input } from 'antd';



import REDUX_ZasedaniyaPravleniyaFederatsii from '../../../objects/ZasedaniyaPravleniyaFederatsii/reducer'

const { TextArea } = Input;



export default function VPDZasedaniyaPravleniyaFederatsiiTekst(props) {

    const {zasedanie} = props;

    const { object } = props;
    // const [city, setCity] = useState([]);

    // useEffect(() => {
    //     auth.fetch('/api/query/City?s-name').then(res => {
    //         if (res && res.data) {
    //             setCity(res.data);
    //         }
    //     });
    // }, []);

    // const options = city.map(i => (
    //     <Option key={i.ID} value={i.ID}>{i.name}</Option>
    // ));
    return (
        <Form
            form={props.form}
            onFinish={props.submit}
            labelAlign={"left"}
            layout={"vertical"}
            initialValues={(object) ? {
                ...((object)?object:{})
            } :
                {
                    kvorumDlyaPrinyatiyaResheniya: 50,
                }}
        >
            {/* <Form.Item
                preserve={"true"}
                // hidden={true}
                name={"zasedaniePravleniyaFederatsiiID"}
                label={"Заседание правления федерации"}
                rules={[{ required: true, message: 'Укажите заседание правления федерации!' }]}
            >
                <Input disabled />
            </Form.Item> */}

            {/* <Form.Item
                name={"nomerVoprosa"}
                label={"Номер вопроса"}
                rules={[{ required: true, message: 'Укажите номер вопроса!' }]}
            >
                <InputNumber min={1} style={{ width: "50%" }} />
            </Form.Item> */}

            <Form.Item
                name={"voprosPovestkiDnya"}
                label={"Вопрос повестки дня"}
                rules={[{ required: true, message: 'Укажите вопрос повестки дня!' }]}
            >
                <TextArea rows={4} />
            </Form.Item>

            <Form.Item
                name={"variantOtvetaDlyaGolosovaniya"}
                label={"Вариант ответа для голосования"}
                rules={[{ required: true, message: 'Укажите вариант ответа для голосования!' }]}
            >
                <Input />
            </Form.Item>

            <Form.Item
                name={"kvorumDlyaPrinyatiyaResheniya"}
                label={"Кворум для принятия решения"}
                rules={[{ required: true, message: 'Укажите кворум для принятия решения!' }]}
            >
                <InputNumber min={0}
                    max={100}
                    formatter={value => `${value}%`}
                    parser={value => Number.parseFloat(value.replace('%', ''))}
                    precision={2}
                    step={0.05}
                    style={{ width: "50%" }} />
            </Form.Item>
        </Form>
    );
}
